const config = {
  backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000'
};

export default config;
